










import { AdcontrolProfile } from "@/models";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class InvestorVodDisclaimer extends Vue {
  @Getter("profile") readonly adcontrolProfile?: AdcontrolProfile;

  get showDisclaimer(): boolean {
    return this.adcontrolProfile?.mediaSourceKind === "msk_vod_and_tv";
  }
}
